import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Coffee } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function WelcomePage() {
  const { user, markWelcomeSeen } = useAuth();
  const navigate = useNavigate();
  const firstName = user?.name?.split(' ')[0] || 'there';

  const handleContinue = async (destination) => {
    await markWelcomeSeen();
    navigate(destination, { replace: true });
  };

  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--primary-xlight)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
      }}
    >
      <div
        style={{
          background: 'var(--white)',
          borderRadius: 'var(--radius-lg)',
          boxShadow: 'var(--shadow-lg)',
          padding: '48px 40px',
          maxWidth: '560px',
          width: '100%',
        }}
      >
        {/* Brand */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '32px' }}>
          <div
            style={{
              background: 'var(--primary)',
              borderRadius: '10px',
              padding: '8px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Coffee size={24} strokeWidth={2} />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: '1.1rem' }}>Leuchtstoff</div>
            <div style={{ fontSize: '0.7rem', color: 'var(--text-light)' }}>Roster</div>
          </div>
        </div>

        {/* Heading */}
        <h1 style={{ fontSize: '1.75rem', fontWeight: 700, marginBottom: '20px' }}>
          Welcome, {firstName}! 👋
        </h1>

        {/* Body */}
        <p style={{ lineHeight: 1.7, color: 'var(--text)', marginBottom: '16px' }}>
          Great to have you on board. We hope this tool helps us all organise our shifts and
          absences more easily — and makes everyone's working life a little smoother.
        </p>
        <p style={{ lineHeight: 1.7, color: 'var(--text)', marginBottom: '16px' }}>
          One important first step: connect your Telegram account to the Roster so you never
          miss anything important — like when availabilities open up for the next roster period,
          or when a colleague needs urgent cover for a shift (which can happen to any of us).
        </p>
        <p style={{ lineHeight: 1.7, color: 'var(--text)', marginBottom: '36px' }}>
          Have fun — and if something is missing or not working, drop us a line at{' '}
          <a href="mailto:personal@leuchtstoff.berlin" style={{ color: 'var(--primary-dark)' }}>
            personal@leuchtstoff.berlin
          </a>
        </p>

        {/* Buttons */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button
            className="btn btn-primary"
            onClick={() => handleContinue('/profile#telegram-section')}
            style={{ padding: '12px 24px', fontSize: '1rem' }}
          >
            Connect Telegram →
          </button>
          <button
            onClick={() => handleContinue('/roster')}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: 'var(--text-light)',
              fontSize: '0.9rem',
              padding: '8px',
              textDecoration: 'underline',
            }}
          >
            I'll set it up later
          </button>
        </div>
      </div>
    </div>
  );
}
